import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  ogImageWidth?: number;
  ogImageHeight?: number;
  publishedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  ogImageWidth,
  ogImageHeight,
  publishedTime,
}: SEOHeadProps) {
  useEffect(() => {
    const fullTitle = `${title} | 猫咪视频大全`;
    document.title = fullTitle;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:site_name', '猫咪视频大全', true);
    setMeta('og:locale', 'zh_CN', true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
      if (ogImageWidth) setMeta('og:image:width', String(ogImageWidth), true);
      if (ogImageHeight) setMeta('og:image:height', String(ogImageHeight), true);
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    if (ogImage) setMeta('twitter:image', ogImage);

    if (publishedTime) {
      setMeta('article:published_time', publishedTime);
    }

    const lastMod = document.querySelector('meta[name="Last-modified"]');
    if (!lastMod) {
      const meta = document.createElement('meta');
      meta.name = 'Last-modified';
      meta.content = new Date().toISOString().split('T')[0];
      document.head.appendChild(meta);
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, ogImageWidth, ogImageHeight, publishedTime]);

  return null;
}